import { createAsyncTypes } from 'utils/ActionCreator'

export const LIST_REQUEST_ASYNC = createAsyncTypes('LIST_REQUEST_ASYNC', 'ResolutionCenter/List')
export const URL_STATE_CHANGE = 'ResolutionCenter/List/URL_STATE_CHANGE'
export const REPORT_SELECT = 'ResolutionCenter/List/REPORT_SELECT'

export const PAGINATE_CHANGE = 'ResolutionCenter/List/PAGINATE_CHANGE'

export const URL_STATE = {
  UNCLASSIFIED: 'unclassified',
  CLASSIFIED: 'classified',
  SCANBACK: 'scanback',
  CHALLENGED: 'challenged',
}

export const MAP_NAME_BY_URL_STATE = {
  unclassified: 'Unclassified',
  classified: 'Classified',
  scanback: 'Scanned Incidents',
  challenged: 'Challenged',
}
